import { memo } from "react";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import { CurrencySymbol } from "consts/general";
import { refund } from "features/transactions/api";
import useActions from "features/general/useActions";
import { NotificationSeverity } from "features/general/types";
import ActionPanel from "ui/molecules/ActionPanel";
import { TriggerableDialog } from "ui/molecules/Dialog";
import When from "ui/support/When";
import { useRefund } from "./support";
import useTransactionAction from "./useTransactionAction";

const Refund = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const { showNotication } = useActions();

    const { isFullRefundAvailable, transactionRefundableAmount } = useRefund(transaction);

    const handleRefund = () => (
        request(() => refund(transaction), {
            onSuccess: ({ data }) => (
                showNotication({
                    severity: NotificationSeverity.Success,
                    message: data.ResultCdcData.DESCRIPTION
                })
            )
        })
    );

    return (
        <TriggerableDialog
            TriggerComponent={({ onClick }) => (
                <When
                    if={isFullRefundAvailable}
                    then={(
                        <LoadingButton
                            data-test-id="transactions.transactionActions.refund"
                            startIcon={(
                                <AccountBalanceWalletIcon />
                            )}
                            loading={isLoading}
                            onClick={onClick}
                            variant='outlined'
                            size='small'
                        >
                            Refund
                        </LoadingButton>
                    )}
                />
            )}
            DialogActionsComponent={({ onClose }) => (
                <ActionPanel
                    sx={{
                        border: 'none',
                        p: 0,
                        m: 0
                    }}
                    CancelActionProps={{
                        disabled: isLoading
                    }}
                    SaveActionProps={{
                        children: 'Proceed',
                        loading: isLoading
                    }}
                    onCancel={onClose}
                    onSave={() => handleRefund()
                        .then(() => onClose())}
                />
            )}
            ModalProps={{
                titleSlot:'Refund',
                disableCloseOnBackdropClick: true,
                DialogProps: {
                    PaperProps: {
                        sx: {
                            maxWidth: '600px !important'
                        }
                    }
                }
            }}
        >
            <Typography
                variant="h6"
                component="h2"
                sx={{
                    px: 1
                }}
            >
                Do you want to proceed with refunding this transaction? {transactionRefundableAmount}{CurrencySymbol.EUR} will be returned to the end user.
            </Typography>
        </TriggerableDialog>
    );
};

export default memo(Refund);
